
<div class="mfa-otp-verify-container">
  <ngx-loading [show]="loading" [config]="{ backdropBorderRadius: '14px' }"></ngx-loading>
  <!-- MFA First Step -->
  <!-- <div class="mfa-first-step" *ngIf="mfaStepFlag === mfaSteps.MfaOptions">
  <h3 class="mfa-Heading">Choose Verification Method</h3>
  <div>
    <p>Please Select any one of the following method to get the <b>One Time Password </b>
  to your registered email id or Phone number.</p>

  <div class="redioBtns">
    <div>
      <label class="container">Email
        <input type="radio" value="Email" name="radio" checked="checked">
        <span class="checkmark"></span>
      </label>
    </div>
    <div>
      <label class="container"> Phone number
        <input type="radio" value="Phone" name="radio" disabled="true">
        <span class="checkmark"></span>
      </label>
    </div>
  </div>
  <div>
    <span class="digit-code-span">You will be receiving a  4 - digit code to your registerd email id or Phone number</span>
  </div>
  <div class="email-error-span" *ngIf="mfaOptionErrorFlag === true">
    <span>Email address is not valid or not available. Please contact CareMore Health Provider Relations at (888)291-1358 or send an
    email to ProviderRelations@caremore.com to update email address.</span>
  </div>
  <div class="btn-sections">
    <button class="do-it-laterBtn" (click)="onCloseBtnClick()">Close</button>
    <button class="proceedBtn" (click)="onGetOtpBtnClick()">Get OTP</button>
  </div>
</div>
</div> -->

<!-- MFA second step -->
@if (mfaStepFlag === mfaSteps.VerifyOTP) {
  <div class="mfa-Second-step">
    <h3 class="heading">Check your email!</h3>
    <div class="otp-sent-section">
      <div>
        <span>Enter the 4 - digit code sent to your <b>{{ userEmailId }}</b></span>
      </div>
      <div class="otp-input-section">
        <form [formGroup]="verifyOtpFormGroup">
          <input type="number" class="InputFields" #inp1 id="inp1" formControlName="inp1" (input)="onInput($event)" (keydown)="onKeydown($event)">
          <input type="number" class="InputFields" #inp2 id="inp2" formControlName="inp2" (input)="onInput($event)" (keydown)="onKeydown($event)">
          <input type="number" class="InputFields" #inp3 id="inp3" formControlName="inp3" (input)="onInput($event)" (keydown)="onKeydown($event)">
          <input type="number" class="InputFields" #inp4 id="inp4" formControlName="inp4" (input)="onInput($event)" (keydown)="onKeydown($event)">
        </form>
        <div>
          <p>Time Remaining <span> {{ displayTime }}</span></p>
        </div>
        @if (otpVerifyErrorFlag === true) {
          <div>
            <p class="otp-invalid-error">The OTP you entered is invalid. Please enter the correct OTP!</p>
          </div>
        }
      </div>
      @if (otpVerifyErrorMsg) {
        <div>
          <p class="otp-invalid-error">{{ otpVerifyErrorMsg }}</p>
        </div>
      }
      <div class="userNote">
        <p>
          If you need to update your email ID, please contact our Provider Relations team at providerrelations&#64;caremore.com or call (888) 291-1358, Option 5, for further assistance.
        </p>
      </div>
      <div>
        @if (isResendAllowed) {
          <div class="resend-code">
            Did not received yet? &nbsp;<a (click)="onResendCodeClick()">Resend Code</a>
          </div>
        }
        @if (!isResendAllowed) {
          <div class="resend-code-msg">
            OTP has been sent to your email. Please wait for the code to arrive.
          </div>
        }
      </div>
      <div class="action-btn-wrapper">
        <button class="btn secondary-btn" (click)="onCloseBtnClick()">Close</button>
        <button class="btn primary-btn" #verifyBtn (click)="onVerifyBtnClick()" [disabled]="!verifyOtpFormGroup.valid">Verify</button>
      </div>
    </div>
  </div>
}
</div>